import { GtfsData, StopsByLine, StopsByDestination, StopPoint } from "./types";

export default function(data: GtfsData): StopsByLine[] {
  if (Object.values(data.stops).length < 1) {
    throw "Aucun arret disponible pour le moment";
  }

  let stopsByLines: { [key: string]: StopsByLine } = {};
  let stopareas = data.stops;
  for (let i in stopareas) {
    let stoparea = stopareas[i];
    let dests = stoparea.dests;

    if (stoparea.isCommercial && stoparea.spoints) {
      stoparea.spoints.forEach(function(spoint) {
        dests = dests.concat(spoint.dests);
      });
    }

    dests.forEach(function(dest) {
      let line = data.lines[dest.service];
      if (line){
        if (!stopsByLines[line.mnemo])
          stopsByLines[line.mnemo] = { line, stopsByDestinations: [] };

        let lineDests = stopsByLines[line.mnemo].stopsByDestinations;
        let destKey = lineDests.findIndex(
          currDest => currDest.destinationName == dest.name
        );
        if (destKey < 0) {
          destKey = stopsByLines[line.mnemo].stopsByDestinations.length;
          let destination: StopsByDestination = {
            destinationName: dest.name,
            stopsRefs: []
          };
          stopsByLines[line.mnemo].stopsByDestinations.push(destination);
        }
        stopsByLines[line.mnemo].stopsByDestinations[destKey].stopsRefs.push(
          stoparea.ref
        );
      }
    });
  }

  return Object.values(stopsByLines).sort(
    (a, b) => a.line.order - b.line.order
  );
}
